import { render, staticRenderFns } from "./profileImage.vue?vue&type=template&id=80822b9c&scoped=true&"
import script from "./profileImage.vue?vue&type=script&lang=ts&"
export * from "./profileImage.vue?vue&type=script&lang=ts&"
import style0 from "./profileImage.vue?vue&type=style&index=0&id=80822b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80822b9c",
  null
  
)

export default component.exports